"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseRoute = void 0;
exports.BaseRoute = '/merchant/security_configuration';
//# sourceMappingURL=SecurityConfiguration.consts.js.map